module.exports = __webpack_public_path__ + "static/p04_flauta-d6249b35475bf042432ce913b0e98101.png";